export class BillingPlan {
    planName: string = "";
    renewalDate: Date | null = null;
    invoices: Invoice[] = [] as Invoice[];

    constructor(init?: Partial<BillingPlan>) {
        if (!init) {
            return;
        }

        Object.assign(this, init);
        this.invoices = (init.invoices ?? []).map(i => new Invoice(i));

        if (init.renewalDate) {
            this.renewalDate = new Date(init.renewalDate);
        }
    }
}

class Invoice {
    issueDate: Date | null = null;
    paidDate: Date | null = null;
    url: string = "";

    constructor(init?: Partial<Invoice>) {
        if (!init) {
            return;
        }

        Object.assign(this, init);

        if (init.issueDate) {
            this.issueDate = new Date(init.issueDate);
        }

        if (init.paidDate) {
            this.paidDate = new Date(init.paidDate);
        }
    }
}
